export function formatDownloadCount(count: number) {
  return new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(
    count
  );
}
